import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "k-item-pos-card__image-container relative-position" }
const _hoisted_2 = {
  key: 0,
  class: "k-item-pos-card__item-info row items-center no-wrap q-py-xs q-px-xs rounded-16 transition absolute"
}
const _hoisted_3 = {
  key: 0,
  class: "k-item-pos-card__color rounded-circle"
}
const _hoisted_4 = {
  key: 1,
  class: "fs-13px fw-500 text-dark-bg-20 q-mx-xs"
}
const _hoisted_5 = {
  key: 1,
  class: "k-item-pos-card__pause-container transition absolute flex"
}
const _hoisted_6 = { class: "row items-center gap-xs no-wrap" }
const _hoisted_7 = { class: "fs-11px fw-500 text-cool-gray-100" }
const _hoisted_8 = {
  key: 2,
  class: "k-item-pos-card__callout bg-white rounded-circle transition absolute q-pa-xs flex flex-center"
}

import defaultImage from 'src/shared/static/images/card-placeholder.jpg'
import { computed, ref } from 'vue'

interface IProps {
  image?: string
  name?: string
  price?: string
  color?: string
  itemNumber?: string | number
  count?: number
  paused?: boolean
  text?: Record<PropertyKey, unknown>
  size?: 'lg' | 'md' | 'sm'
  imageless?: boolean
  callout?: Record<PropertyKey, unknown> | null
}

interface IEmits {
  (event: 'select', data: number | string): void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KItemPosCard' },
  __name: 'KItemPosCard',
  props: {
    image: { default: '' },
    name: { default: '' },
    price: { default: '' },
    color: { default: '' },
    itemNumber: { default: '' },
    count: { default: 0 },
    paused: { type: Boolean, default: false },
    text: { default: () => ({}) },
    size: { default: 'md' },
    imageless: { type: Boolean, default: false },
    callout: { default: null }
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v76553f3f": (_ctx.color)
}))


const props = __props
const emit = __emit

const sizeRef = ref({
  sm: {
    card: {
      maxWidth: '162px',
      minHeight: '196px',
    },
    image: {
      width: '152px',
      height: '100px',
    },
    name: 'fs-13px',
    price: 'fs-13px',
  },
  md: {
    card: {
      maxWidth: '188px',
      minHeight: '228px',
    },
    image: {
      width: '178px',
      height: '124px',
    },
    name: 'fs-15px',
    price: 'fs-15px',
  },
  lg: {
    card: {
      maxWidth: '226px',
      minHeight: '270px',
    },
    image: {
      width: '216px',
      height: '150px',
    },
    name: 'fs-15px',
    price: 'fs-15px',
  },
})

const imagelessSizeRef = ref({
  sm: {
    card: {
      maxWidth: '162px',
      maxHeight: '128px',
    },
    image: {
      width: '152px',
      height: '0',
    },
    name: sizeRef.value.sm.name,
    price: sizeRef.value.sm.price,
  },
  md: {
    card: {
      maxWidth: '188px',
      minHeight: '128px',
    },
    image: {
      width: '178px',
      height: '0',
    },
    name: sizeRef.value.md.name,
    price: sizeRef.value.md.price,
  },
  lg: {
    card: {
      maxWidth: '226px',
      minHeight: '128px',
    },
    image: {
      width: '216px',
      height: '0',
    },
    name: sizeRef.value.lg.name,
    price: sizeRef.value.lg.price,
  },
})

const containerSize = computed(() => {
  if (props.imageless) return `k-item-pos-card--imageless-size-${props.size}`
  else return `k-item-pos-card--size-${props.size}`
})

const sizeRelatedStyles = computed(() => {
  if (props.imageless) return imagelessSizeRef.value[props.size]
  else return sizeRef.value[props.size]
})

const onItemCardClicked = () => {
  if (!props.paused) emit('select', props.itemNumber)
}

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_k_icon = _resolveComponent("k-icon")!
  const _component_k_badge = _resolveComponent("k-badge")!
  const _component_k_callout = _resolveComponent("k-callout")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["k-item-pos-card rounded-16 q-pa-xs bg-white-shadow shadow-1 full-width column gap-xs items-center justify-between transition cursor-pointer", [
      {
        'k-item-pos-card--paused cursor-not-allowed': __props.paused,
        'k-item-pos-card--selected': __props.count > 0,
        'k-item-pos-card--imageless': __props.imageless,
      },
      containerSize.value,
    ]]),
    onClick: onItemCardClicked
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_img, {
        src: __props.image || _unref(defaultImage),
        "placeholder-src": _unref(defaultImage),
        fit: "cover",
        width: sizeRelatedStyles.value.image.width,
        height: sizeRelatedStyles.value.image.height,
        class: _normalizeClass(["k-item-pos-card__image rounded-12 transition", { 'k-item-pos-card__image--paused': __props.paused }])
      }, null, 8 /* PROPS */, ["src", "placeholder-src", "width", "height", "class"]),
      (__props.color || __props.itemNumber !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (__props.color)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3))
              : _createCommentVNode("v-if", true),
            (__props.itemNumber !== 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.itemNumber), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      (__props.paused)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_k_badge, {
              "border-color": "caution-70",
              color: "white",
              hoverless: "",
              class: "k-item-pos-card__pause-badge"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_k_icon, {
                    name: "pause",
                    color: "caution-100",
                    size: "16px"
                  }),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(__props.text?.paused ?? 'Paused'), 1 /* TEXT */)
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : _createCommentVNode("v-if", true),
      (__props.callout && !__props.paused)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_k_callout, _normalizeProps(_guardReactiveProps(__props.callout)), null, 16 /* FULL_PROPS */)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("span", {
      class: _normalizeClass(["k-item-pos-card__name text-center fw-500 text-cool-gray-100 q-px-xs ellipsis-2-lines", [sizeRelatedStyles.value.name, __props.paused ? 'text-cool-gray-70' : 'text-cool-gray-100']])
    }, _toDisplayString(__props.name), 3 /* TEXT, CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(["k-item-pos-card__price-container rounded-12 q-pa-xs bg-off-white-10 row items-center full-width relative-position", [__props.count === 0 ? 'justify-center' : 'justify-end']])
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["k-item-pos-card__price absolute transition fw-600 text-cool-gray-100", [
          { 'has-count': __props.count > 0 },
          sizeRelatedStyles.value.price,
          __props.paused ? 'text-cool-gray-70' : 'text-cool-gray-100',
        ]])
      }, _toDisplayString(__props.price), 3 /* TEXT, CLASS */),
      _createElementVNode("span", {
        class: _normalizeClass(["k-item-pos-card__selected-count row items-center justify-center transition q-px-12 bg-space-b-d rounded-16 text-white fw-500 fs-13px text-center", { show: __props.count > 0 }])
      }, " × " + _toDisplayString(__props.count), 3 /* TEXT, CLASS */)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}
}

})